module.exports = __webpack_public_path__ + "media/images/brands/marque-wella-079365c9da70a46446c5bb7f3dd6d98a.jpg";